import fields from "./form_json/en/contract_signed_details.json";

export default fields;
